import { models as coreModels } from '@ps/web-core-store';

import account from './account';
import auth from './auth';
import casino from './casino';
import chestInventory from './chestInventory';
import cms from './cms';
import crm from './crm';
import documentVisibility from './documentVisibility';
import help from './help';
import notification from './notification';
import nps from './nps';
import rewards from './rewards';
import rewardsExchange from './rewardsExchange';
import rewardsLegacy from './rewardsLegacy';
import search from './search';
import spinOfTheDay from './spinOfTheDay';
import * as sports from './sports';
import system from './system';

type FullyMigratedModels = Omit<typeof coreModels, 'cms' | 'account' | 'rewards'>;

export type Models = Omit<typeof models, keyof FullyMigratedModels>;

const models = {
  account,
  activeGames: coreModels.activeGames,
  auth,
  casino,
  chestInventory,
  cms,
  country: coreModels.country,
  config: coreModels.config,
  crm,
  currency: coreModels.currency,
  device: coreModels.device,
  feature: coreModels.feature,
  help,
  locale: coreModels.locale,
  localSettings: coreModels.localSettings,
  modal: coreModels.modal,
  location: coreModels.location,
  notification,
  nps,
  resolver: coreModels.resolver,
  spinOfTheDay,
  rewards,
  rewardsExchange,
  rewardsLegacy,
  search,
  session: coreModels.session,
  system,
  timeZone: coreModels.timeZone,
  documentVisibility,
  ...sports
};

export default models;
